import React from 'react';
import wrapWithProvider from "./wrap-with-provider"

export const wrapRootElement = wrapWithProvider;

export const wrapPageElement = ({ element, props }) => {
  return <>{element}</>
}